import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "card-px text-center py-20 my-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2x fw-bolder mb-10" }, "Usuario creado exitosamente", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 fs-5 fw-bold mb-13" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hemos enviado la bienvenida al nuevo usuario y las instrucciones para acceder al portal de proveedores, junto a su clave de acceso generada por el sistema.")
], -1)
const _hoisted_6 = { class: "text-center px-5" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_router_link, {
          to: { name: 'apps-customers-listing' },
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Continuar ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: _ctx.getIllustrationsPath('2.png'),
          alt: "",
          class: "mw-100 mh-300px"
        }, null, 8, _hoisted_7)
      ])
    ])
  ]))
}